<template>
    <div class="pause modal-2" v-if='getModalPause'>
        <div class="modal-content-my">
            <form class='form-modal'>
                <div class="modal-head">
                    <h3 class="title-text">Pausas</h3>
                    <span @click='btnClose' class='closeBtn'>&times;</span>
                </div>
                <div class="opcoes" v-for='pause in getPauses' @click='clickPause(pause.id, pause.name)'
                    :key='pause.id'>
                    <p class='opcao'>{{ pause.name }}</p>
                </div>
            </form>

        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { connection } from "../../../connetions/amiCon.js"

export default {
    computed: {
        ...mapGetters(['getModalPause', 'getPauses', 'getId', 'getExtension', 'getPauseTime'])
    },
    methods: {
        ...mapActions(['setModalPause', 'selectPause', 'sendPauseApi', 'setExtension', 'setPauseTime', 'sendOperatorPauseApi']),
        btnClose() {
            this.setModalPause();
        },
        getTime() {
            var d = new Date();
            var h = d.getHours();
            var m = d.getMinutes();
            var s = d.getSeconds();
            var time = d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
            return time;

        },
        /*
        clickPause(id, pause) {
            connection.emit('QueuePause', {
                reason: pause,
                extension: user.getExtension()
            });
            
            const userQueues = user.getQueue();
            if(userQueues.length){
                userQueues.map(queue => {
                    const dataPause = {
                      pauseId: pause,
                      tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
                      queue: queue,
                      userId: user.getId()
                    };
                
                    this.sendOperatorPauseApiRealtime(dataPause);
                })
            }
             
            this.setModalPause();
        }
        */

        async clickPause(id, pause) {
            const userQueues = user.getQueue();
            const tempo = moment().format('YYYY-MM-DD HH:mm:ss');

            if (!userQueues || !userQueues.length) {
                return;
            }

            // Envia TODAS as filas de uma vez só
            const dataPause = {
                pauseId: pause,
                tempo: tempo,
                queues: userQueues, // Array com todas as filas
                userId: user.getId()
            };

            const resp = await this.sendOperatorPauseApi(dataPause);

            if (!resp || resp.success === false) {
                return;
            }

            connection.emit('QueuePause', {
                reason: pause,
                extension: user.getExtension()
            });

            this.setModalPause();
        }
    }
}
</script>
